<template>
  <div class="forestEvaluatePage">
    <div class="evaluateBox">
      <van-row gutter="20" class="itemBox">
        <van-col
          v-for="item in listData"
          :key="item.id"
          class="itemList"
          @click="addGoodNumber(item)"
        >
          {{ item.evaluateName }}
          <van-icon
            :info="`${
              parseFloat(item.num) > 99 ? (item.num = '99+') : item.num
            }`"
            v-if="item.num != '0'"
            class="goodNumber"
          />
        </van-col>
      </van-row>
      <!-- <a herf="javascript:void(0);" class="addItem" @click="addItem">我要补充...</a> -->
    </div>
    <!-- 弹出层 -->
    <!-- <van-dialog v-model="addItemShow" title="添加评价" show-cancel-button @confirm="saveUserEvaluateValue"
            @close="closePicker">
            <van-field v-model="UserEvaluateValue" rows="2" autosize type="textarea" maxlength="10" placeholder="请输入评价"
                show-word-limit />
    </van-dialog>-->
  </div>
</template>
<script>
/*eslint-disable*/

// import { getToken } from "@/utils/common";
import { mapState, mapMutations } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "forestEvaluate",
  data() {
    return {
      userPoint: "", //用户所在位置
      interiorPoint: "", //林地地址

      listData: [],
      UserEvaluateValue: "", //用户添加的评价
      addItemShow: false,
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();
    window.setUserPoint = this.setUserPoint;
    this.$nextTick(function () {
      this.forestId = this.$route.query.commonId;
      if (this.forestId == undefined) {
        this.forestId = this.dataInfo.id;
      }
      this.getAppPoint();
      this.getPoint();
    });
  },
  methods: {
    ...mapMutations(["setForestEvaluateObj"]),
    getPoint() {
      let _this = this;
      _this.$api.universal.forest
        .forestMsg(_this.forestId)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.interiorPoint = res.data.interiorPoint;
            _this.getInitPage();
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getInitPage() {
      let _this = this;
      _this.$api.universal.forest
        .forestEvaluateList({
          interiorPoint: _this.interiorPoint,
        })
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            _this.listData = Object.assign({}, _this.listData, res.data);
            for (let i = 0; i < _this.listData.length; i++) {
              _this.listData.addGoodType = true;
            }
          } else {
            console.log(res.msg);
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    addItem() {
      let _this = this;
      let data = {
        addItemShow: true,
        forestPoint: this.interiorPoint,
        interiorPoint: this.userPoint,
      };
      _this.setForestEvaluateObj(data);
    },
    // saveUserEvaluateValue() {
    //     let _this = this;
    //     let userContentData = {
    //         evaluateContent: this.UserEvaluateValue,
    //         interiorPoint: this.userPoint,
    //     }
    //     _this.$api.universal.forest.ReplenishEvaluate(userContentData)
    //         .then(res => {
    //             if (res.code == "1") {
    //                 _this.$toast("补充添加林地评价成功");
    //                 _this.getInitPage()
    //             } else {
    //                 console.log(res.msg);
    //                 _this.$toast(res.msg);
    //             }
    //         })
    //         .catch(err => {
    //             console.log(err);
    //         });

    // },
    // closePicker() {//关闭弹框将值清零
    //     this.UserEvaluateValue = "";
    // },
    addGoodNumber(data) {
      let _this = this;
      //interiorPoint  需要安卓IOS交互返回当前位置
      if (data.addGoodType == false) {
        _this.$toast(_this.$t("common.moreClickToastMsg"));
      } else {
        data.addGoodType = false;
        if (data.isEvaluate) {
          //取消点赞
          let dto = {
            evaluate: data.evaluate,
            point: this.userPoint,
            interiorPoint: this.interiorPoint,
            type: "2",
          };
          console.log(JSON.stringify(dto));
          _this.$api.universal.forest
            .addAreaEvaluate(dto)
            .then((res) => {
              if (res.code == "1") {
                console.log(res.data);
                if (parseFloat(data.num) < 0 || parseFloat(data.num) == 0) {
                  data.num = 0;
                } else {
                  data.num = parseFloat(data.num) - 1;
                }
                data.isEvaluate = false;
                _this.$toast(_this.$t("common.qxEvaluateTit"));
              } else {
                console.log(res.msg);
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          //新增点赞
          let dto = {
            evaluate: data.evaluate,
            point: this.userPoint,
            interiorPoint: this.interiorPoint,
            type: "1",
          };
          _this.$api.universal.forest
            .addAreaEvaluate(dto)
            .then((res) => {
              if (res.code == "1") {
                console.log(res.data);
                if (data.num == "0" || data.num == "") {
                  data.num = 1;
                } else {
                  data.num = parseFloat(data.num) + 1;
                }
                data.isEvaluate = true;
                _this.$toast(_this.$t("common.cgEvaluateTit"));
              } else {
                console.log(res.msg);
                _this.$toast(res.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
        setTimeout(function () {
          data.addGoodType = !data.addGoodType;
        }, 5000);
      }
    },
    getAppPoint() {
      //获取用户当前的位置

      if (this.clientType == "android") {
        window.android.getInfo(117);
      } else {
        window.webkit.messageHandlers.getUserPoint.postMessage({
          callBack: "setUserPoint", //回调 必传
        });
      }
    },
    setUserPoint(data) {
      if (this.clientType == "android") {
        let cord = data.split(" ");
        if (cord.length == 2) {
          this.userPoint = "POINT(" + cord[0] + " " + cord[1] + ")";
        }
      } else {
        let dataObj = JSON.parse(data);
        this.userPoint = "POINT(" + dataObj.lon + " " + dataObj.lat + ")";
      }
    },
  },
  computed: {
    ...mapState(["ForestEvaluateReload"]),
  },
  watch: {
    dataInfo: {
      handler: function () {
        let _this = this;
        _this.forestId = this.dataInfo.id;
        _this.getPoint();
      },
      deep: true,
    },
    ForestEvaluateReload: function (newValue) {
      if (newValue != "") {
        this.getInitPage();
      }
    },
  },
};
</script>
<style lang="less">
.forestEvaluatePage {
  width: 100%;
  height: 100%;

  .evaluateBox {
    width: 100%;
    padding: 8px 16px 0;

    .itemBox {
      width: 100%;

      .itemList {
        position: relative;
        padding: 0 20px !important;
        height: 40px;
        line-height: 40px;
        border: 1px solid #f6f6f6;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        margin: 10px 3%;
        text-align: center;
        font-size: 14px;
        color: #333;

        .goodNumber {
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
    }

    .addItem {
      display: inline-block;
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #f6f6f6;
      border-radius: 8px;
      -webkit-border-radius: 8px;
      -moz-border-radius: 8px;
      margin: 10px 3% 10px 0;
      text-align: center;
      font-size: 14px;
      color: #333;
    }
  }
}
</style>